'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002499 from "./presto.-Two-Factor-Auth-View$$anon$99.js";
import * as $j_presto$002etypes$0024$002dRole$0024 from "./presto.types$-Role$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dId$0024 from "./presto.types$-Role-Id$.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024 from "./presto.types$-Role-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$98() {
  this.bJP = null;
  this.bJH = null;
  this.bJI = false;
  this.bJQ = null;
  this.bJR = false;
  this.bJU = null;
  this.bJN = null;
  this.bJO = false;
  this.bJJ = null;
  this.bJK = false;
  this.bJL = null;
  this.bJM = false;
  this.bJS = false;
  this.bJT = false;
  this.bJP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bJU = "Role";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$98 as $c_Lpresto_TwoFactorAuthView$$anon$98 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$98;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$98() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$98 as $h_Lpresto_TwoFactorAuthView$$anon$98 };
$h_Lpresto_TwoFactorAuthView$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bJP;
});
$p.L = (function() {
  if ((!this.bJI)) {
    this.bJH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bJI = true;
  }
  return this.bJH;
});
$p.O = (function() {
  if ((!this.bJR)) {
    this.bJQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bJR = true;
  }
  return this.bJQ;
});
$p.E = (function() {
  return this.bJU;
});
$p.t = (function() {
  if ((!this.bJO)) {
    this.bJN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.bJO = true;
  }
  return this.bJN;
});
$p.M = (function() {
  if ((!this.bJK)) {
    this.bJJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dId$0024.$m_Lpresto_types$RoleId$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dName$0024.$m_Lpresto_types$RoleName$().nM(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.bJK = true;
  }
  return this.bJJ;
});
$p.Q = (function() {
  if ((!this.bJM)) {
    this.bJL = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002499.$c_Lpresto_TwoFactorAuthView$$anon$99();
    this.bJM = true;
  }
  return this.bJL;
});
$p.w = (function() {
  if ((!this.bJT)) {
    this.bJS = false;
    this.bJT = true;
  }
  return this.bJS;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee1056) => ((p) => \u03b4scrutinee1056.nG(p)))($j_presto$002etypes$0024$002dRole$0024.$m_Lpresto_types$Role$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$98, "presto.TwoFactorAuthView$$anon$98", ({
  TD: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$98 as $d_Lpresto_TwoFactorAuthView$$anon$98 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$98.js.map
